// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1vOQ-","label":"SetPasswdForm_label__1aEio"};